import { render, staticRenderFns } from "./SuficienciaImport.vue?vue&type=template&id=a0af2f6a&"
import script from "./SuficienciaImport.vue?vue&type=script&lang=js&"
export * from "./SuficienciaImport.vue?vue&type=script&lang=js&"
import style0 from "./SuficienciaImport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports